module.exports = __webpack_public_path__ + "img/logo-ALC.e1bc99b6.svg";